module.exports = __webpack_public_path__ + "static/img/bxecode-xcx.4b95db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/images/bxecode-xcx.png
// module id = jKaf
// module chunks = 57